import moment from 'moment';
import {
  adminRequestStatus,
  LANGUAGE_TO_POLICY_URL,
  LANGUAGE_TO_POLICY_URL_END,
  LANGUAGE_TO_TERMS_URL,
  NO_COMPANY,
  signUpFromIndicator,
  userNewsStatus,
} from './constants';
import dispoIcon from '../assets/dispo.svg';
import accountIcon from '../assets/account.svg';
import portalIcon from '../assets/portal.svg';
import wiserHomeIcon from '../assets/wiserhome.svg';
import learnetzIcon from '../assets/learnetz.svg';
import esetupIcon from '../assets/esetup.svg';
import { BRANCH_NOT_FOUND } from '../pages/ProfilePage/constants';

export const isEmailInvalid = email => {
  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email) || email.length > 255;
};

export const setLanguageToLegalPolicyUrl = languageKey => {
  return LANGUAGE_TO_POLICY_URL[languageKey];
};

export const setLanguageToLegalPolicyUrlEnd = languageKey => {
  return LANGUAGE_TO_POLICY_URL_END[languageKey];
};

export const setLanguageToLegalTermsUrl = languageKey => {
  return LANGUAGE_TO_TERMS_URL[languageKey];
};

export const isButtonForNewslettersSubscribeDisabled = (isSubmitting, values, errors, userSubscriptionStatus) => {
  if (!values.interests.every(i => !i.interested)) {
    return isSubmitting || Object.keys(errors).length !== 0 || !values.marketingUpdates;
  }
  return (
    userSubscriptionStatus === userNewsStatus.UNSUBSCRIBED ||
    userSubscriptionStatus === userNewsStatus.NOT_SUBSCRIBED_YET
  );
};

export const getMessageKeyForAdminRequestStatus = status => {
  switch (status) {
    case adminRequestStatus.OPEN:
      return 'companyInfo.statusMessage';
    case adminRequestStatus.APPROVED:
      return 'companyInfo.statusManaged';
    default:
      return '';
  }
};

export const getFullUsername = (firstName, lastName) => {
  return [firstName, lastName].join(' ');
};

export const getMappedUsersForDropdownMenu = usersList => {
  return usersList.map(profUser => {
    const { User } = profUser;
    return {
      label: getFullUsername(User.firstName, User.lastName),
      value: User.id,
    };
  });
};

export const getDescriptionDeleteAccountSuccessorModal = (description, companyName) => {
  return description.replace('%%COMPANY_NAME%%', companyName);
};

export const getDescriptionForSelectSuccessorModal = (description, companyName) => {
  return getDescriptionDeleteAccountSuccessorModal(description, companyName);
};

export const getNewCompanyAdminSuccessfulUpdatedMessage = (message, successor, companyName) => {
  return message.replace('%%SUCCESSOR%%', successor).replace('%%TARGET_COMPANY%%', companyName);
};

// wiserhome icon has no properly design, add shadow as all others
export const getClientIconByUserData = userSignUpFrom => {
  switch (userSignUpFrom) {
    case signUpFromIndicator.DISPO:
      return dispoIcon;
    case signUpFromIndicator.ACCOUNT:
      return accountIcon;
    case signUpFromIndicator.PORTAL:
      return portalIcon;
    case signUpFromIndicator.WISERHOME:
      return wiserHomeIcon;
    case signUpFromIndicator.LERNETZ:
      return learnetzIcon;
    case signUpFromIndicator.ESETUP:
      return esetupIcon;
    default:
      return accountIcon;
  }
};

export const capitalizeFirstLetter = str => {
  return `${str.slice(0, 1).toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const getCompanyAdminStatus = userCompanies => {
  return userCompanies.length > 0 ? userCompanies[0].admin.isManaged : NO_COMPANY;
};

export const isUserCompanyOrBranchOwner = (company, branch) => {
  if (branch && branch.BranchUser && branch.BranchUser.isOwner) {
    return true;
  }
  return company && company.CompanyUser && company.CompanyUser.isOwner;
};

export const getFullAddress = (street, zipCode, city) => {
  if (!city) {
    return BRANCH_NOT_FOUND;
  }
  return `${street}, ${zipCode} ${city.replace(/[0-9]/g, '')}`;
};

export const getCompanyAndBranchStatuses = (company, branch) => {
  const companyStatus = company && company.CompanyUser && company.CompanyUser.status;
  const branchStatus = branch && branch.BranchUser && branch.BranchUser.status;
  return {
    companyStatus,
    branchStatus,
  };
};

export const formatLink = link => {
  if (!link) {
    return null;
  }

  if (link.startsWith('www.')) {
    return ['//', link].join('');
  }

  if (link.startsWith('http:')) {
    return link.replace('http:', '');
  }

  if (link.startsWith('https:')) {
    return link.replace('https:', '');
  }

  if (link.startsWith('//')) {
    return link;
  }

  return `//www.${link}`;
};

export const formatDate = date => {
  return moment(date).format('DD.MM.YYYY');
};
